
import SavingsInitialArray from "../datasets/savings_initial_array";
import Retirement401KInitialArray from "../datasets/retirement_401K_initial_array";
import SavingsPolicyOptions from "../datasets/savings_policy_options";

export const initializeSavingsInfoArr = (savingsClass) => {
     let savingsPolicyOptions = SavingsPolicyOptions;
     let savingsElements = SavingsInitialArray;
     if (savingsClass === "retirement"){
          savingsElements = Retirement401KInitialArray;
     }
     let savingInfoArr = [];
     for (let i=0; i<savingsPolicyOptions.length; i++){
          if (savingsPolicyOptions[i].savingsClass === savingsClass){
               const savingsType = savingsPolicyOptions[i].type;
               let savingInfoObj = 
                    JSON.parse(JSON.stringify(savingsElements.find(elem => elem.savingsType === "default")));
               const savingTypeSpecific = savingsElements.find(elem => elem.savingsType === savingsType);
               savingInfoObj.savingsType = savingsType;
               savingInfoObj.savingsClass = savingsPolicyOptions[i].savingsClass;
               if (savingTypeSpecific){
                    savingInfoObj = {...savingInfoObj, ...savingTypeSpecific}
                   
               }
               savingInfoArr.push(savingInfoObj);
          }
     }
     return savingInfoArr;
}

export default initializeSavingsInfoArr;